import { ReportLocationEnum, ReportNote } from '@/types/alert';

type NoteSource = {
  notes?: Array<Pick<ReportNote, 'note' | 'location'>> | null;
  alerts?: Array<{ notes?: Array<Pick<ReportNote, 'note'>> | null }> | null;
};

export const ALERT_NOTE_FEED_LIMIT = 120;

export function clipAlertNote(value: string | null | undefined, limit = ALERT_NOTE_FEED_LIMIT): string | null {
  const text = value?.replace(/\s+/g, ' ').trim();
  if (!text) return null;
  if (text.length <= limit) return text;
  return `${text.slice(0, limit).trimEnd()}…`;
}

export function joinAlertNotes(...parts: Array<string | null | undefined>): string | null {
  const seen = new Set<string>();
  const lines: string[] = [];
  for (const part of parts) {
    for (const line of (part ?? '').split('\n')) {
      const value = line.trim();
      if (!value || seen.has(value)) continue;
      seen.add(value);
      lines.push(value);
    }
  }
  return lines.length ? lines.join('\n') : null;
}

/** Alert-card notes saved on a signed transmission report. */
export function reportAlertNoteText(report: NoteSource | null | undefined): string | null {
  if (!report) return null;
  const lines: string[] = [];
  for (const note of report.notes ?? []) {
    if (note.location === ReportLocationEnum.Alert) lines.push(note.note);
  }
  for (const alert of report.alerts ?? []) {
    for (const note of alert.notes ?? []) lines.push(note.note);
  }
  return joinAlertNotes(...lines);
}
